@if (linkClickObserved$()) {
  <sol-content [content]="content$()" [linkTarget]="linkTarget$()" (linkClick)="onLinkClick($event)" />
} @else {
  <sol-content [content]="content$()" [linkTarget]="linkTarget$()" />
}
